import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { About } from "./components/About/About";
import { Banner } from "./components/Banner";
import { Footer } from "./components/Footer";
import { NavBar } from "./components/NavBar";
import { Projects } from "./components/Projects";
import Services from "./components/Services";
import { Skills } from "./components/Skills";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Services />
      <About />
      <Footer />
    </div>
  );
}

export default App;